import request from '@/utils/request'
let resquest = process.env.VUE_APP_BASE_API

export default {
  /* ---------------------------------邀请码相关接口---------------------------- */
  //绑定邀请码
  inviteCodeBind(data) {
    return request({
      url: `${resquest}/novel/app/user/invite/code`,
      method: 'post',
      data
    })
  },
}